import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

// Název aktuálně načteného JS bundlu (hash se mění s každým buildem).
function currentBundle(): string {
  const s = document.querySelector('script[type="module"][src*="/assets/index-"]') as HTMLScriptElement | null
  return s ? (s.src.split('/').pop() || '') : ''
}

/**
 * Při přechodu na stránku (throttle 60 s) ověří, zda na serveru neběží novější build.
 * Pokud ano, načte ho plným reloadem — uživateli se tak po deployi neukazuje stará
 * (např. ještě nepřeložená) verze ze zaseknuté záložky.
 */
export default function VersionGuard() {
  const { pathname } = useLocation()
  const loaded = useRef(currentBundle())
  const lastCheck = useRef(0)

  useEffect(() => {
    const now = Date.now()
    if (now - lastCheck.current < 60_000) return
    lastCheck.current = now
    if (!loaded.current) return
    fetch('/index.html', { cache: 'no-store' })
      .then((r) => r.text())
      .then((html) => {
        const m = html.match(/assets\/index-[A-Za-z0-9_-]+\.js/)
        const latest = m ? m[0].split('/').pop() : ''
        if (latest && latest !== loaded.current) window.location.reload()
      })
      .catch(() => { /* offline / chyba sítě — ignorujeme */ })
  }, [pathname])

  return null
}
